function normalizeInvitePhone(value) {
  if (!value) {
    return ''
  }

  const trimmedValue = String(value).trim().replace(/\s+/g, '')
  if (!trimmedValue) {
    return ''
  }

  const hasLeadingPlus = trimmedValue.startsWith('+')
  const digitsOnlyValue = trimmedValue.replace(/\D/g, '')
  if (!digitsOnlyValue) {
    return ''
  }

  return hasLeadingPlus ? `+${digitsOnlyValue}` : digitsOnlyValue
}

function normalizeInviteIdentity(value) {
  if (!value) {
    return ''
  }

  const trimmedValue = String(value).trim()
  if (!trimmedValue) {
    return ''
  }

  if (trimmedValue.includes('@')) {
    return trimmedValue.toLowerCase()
  }

  return normalizeInvitePhone(trimmedValue) || trimmedValue
}

export function isInvitaionBelongingToUser({ invitationData, profileData }) {
  if (!profileData) {
    return true
  }
  if (!invitationData?.loginUsernameId) {
    return false
  }

  const invitationIdentity = normalizeInviteIdentity(invitationData?.loginUsernameId)
  if (!invitationIdentity) {
    return false
  }

  return (
    invitationIdentity === normalizeInviteIdentity(profileData?.email) ||
    invitationIdentity === normalizeInviteIdentity(profileData?.mobile)
  )
}

export function isUserLoggedIn({ profileData }) {
  return !!profileData
}
